import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { getMenuInfo, deleteAllSaveSearch, deleteSaveSearch, addUserFavorite, deleteUserFavorite, removeFavourites
//@ts-ignore
} from "@services/publicUserAPI";
//@ts-ignore
import { saveSearch } from "@services/realEstateAPI";
//@ts-ignore
import { sendAgencyContactAsync } from "@services/agencyAPI";
//@ts-ignore
import { hashEmail } from "@utils/EmailUtils";
//@ts-ignore
import { encodeCookie, removeCookie } from "@utils/CookieUtils";
import { defineStore } from "pinia";
import { ref, computed } from "vue";
//@ts-ignore
import { sendConsultantRequestContact } from "@services/AuctionAPI";
var insertHashedEmailCookie = email => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var hashedEmail = yield hashEmail(email);
    window.dataLayer.push({
      "hashedEmail": hashedEmail,
      "event": "hashedEmailInserted"
    });
    /* We want always to have a single email in our cookie! */
    removeCookie(email);
    encodeCookie("hashedEmail", hashedEmail, 30, false);
  } catch (err) {
    console.error(err);
  }
});
export var usePublicUserMenuStore = defineStore("publicUserMenuStoreId", () => {
  var name = ref("");
  var email = ref("");
  var mailConfirmed = ref(null);
  var favoriteIdList = ref([]);
  var requestsCounter = ref(0);
  var savedSearchesCounter = ref(0);
  var lastLoginDate = ref("");
  var publicUserId = ref(-1);
  var marketing = ref(false);
  var lastFavouriteModifiedId = ref(-1);
  var favoritesCounter = computed(() => favoriteIdList.value.length);
  var getFavoriteById = id => {
    return favoriteIdList.value.findIndex(_id => _id === id);
  };
  var initState = _publicUserMenuInfo => {
    publicUserId.value = _publicUserMenuInfo.publicUserId;
    favoriteIdList.value = _publicUserMenuInfo.favouriteIdList;
    mailConfirmed.value = _publicUserMenuInfo.mailConfirmed;
    name.value = _publicUserMenuInfo.name;
    savedSearchesCounter.value = _publicUserMenuInfo.saveSearchCount;
    requestsCounter.value = _publicUserMenuInfo.sentRequestsCount;
    lastLoginDate.value = _publicUserMenuInfo.lastLoginDate;
    email.value = _publicUserMenuInfo.email;
    //@ts-ignore
    marketing.value = _publicUserMenuInfo.marketing;
    /* Adding the email to GTM */
    window.dataLayer.push({
      "email": email.value
    });
    /* Adding cookie */
    insertHashedEmailCookie(email.value);
  };
  var setMarketing = newVal => {
    marketing.value = newVal;
  };
  var setSavedSearches = newVal => {
    savedSearchesCounter.value = newVal;
  };
  var increaseSavedSearches = () => {
    savedSearchesCounter.value = savedSearchesCounter.value + 1;
  };
  var decreaseSavedSearchesCounter = () => {
    savedSearchesCounter.value = savedSearchesCounter.value - 1;
  };
  var setUserFavorite = newVal => {
    favoriteIdList.value = newVal;
  };
  var increaseRequestCounter = () => {
    requestsCounter.value = requestsCounter.value + 1;
  };
  //TODO: questa reset la si può sovrascrivere con il metodo reset (da provare)
  var resetPublicUserMenuStore = () => {
    /*Removing the cookie*/
    removeCookie("hashedEmail");
    name.value = "";
    email.value = "";
    mailConfirmed.value = null;
    favoriteIdList.value = [];
    requestsCounter.value = 0;
    savedSearchesCounter.value = 0;
    lastLoginDate.value = "";
    marketing.value = false;
  };
  var getPublicUserMenuInfo = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
      var data = yield getMenuInfo();
      window.dataLayer.push({
        user_id: data.publicUserId
      });
      initState(data);
    } catch (error) {
      console.error(error); //This should never happen!
    }
  });
  var addSaveSearch = payload => __awaiter(void 0, void 0, void 0, function* () {
    var {
      email,
      title,
      hourly,
      resb,
      pushNotifications
    } = payload;
    yield saveSearch(email, title, hourly, resb, pushNotifications);
    //The commit will happen iff there is no error
    increaseSavedSearches();
  });
  //SAVE SEARCH
  var deleteSavedSearches = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
      yield deleteAllSaveSearch();
      savedSearchesCounter.value = 0;
    } catch (error) {
      console.error(error); //This should never happen!
    }
  });
  var deleteSaveSearchById = idToDelete => __awaiter(void 0, void 0, void 0, function* () {
    try {
      yield deleteSaveSearch(idToDelete);
      savedSearchesCounter.value -= 1;
    } catch (error) {
      console.error(error);
    }
  });
  //FAVORITES
  var addFavorite = id => __awaiter(void 0, void 0, void 0, function* () {
    var res = yield addUserFavorite(id);
    if (res) {
      favoriteIdList.value.push(id);
      lastFavouriteModifiedId.value = id;
    } else throw "We could not add the favorite to the user";
  });
  var removeFavorite = id => __awaiter(void 0, void 0, void 0, function* () {
    var res = yield deleteUserFavorite(id);
    if (!res) throw "We could not remove the favorite!";
    try {
      favoriteIdList.value = favoriteIdList.value.filter(favoriteId => favoriteId !== id);
      lastFavouriteModifiedId.value = id;
    } catch (error) {
      console.error(error);
    }
  });
  var removeFavorites = () => __awaiter(void 0, void 0, void 0, function* () {
    var res = yield removeFavourites();
    if (!res) throw "We could not remove all the favorites";
    favoriteIdList.value = [];
  });
  //REQUESTS
  var sendAgencyContact = contact => __awaiter(void 0, void 0, void 0, function* () {
    var res = yield sendAgencyContactAsync(contact);
    if (res && mailConfirmed.value)
      //If the email is not confirmed, we won't increase the counter!
      increaseRequestCounter();
    return res;
  });
  var sendConsultantAuctionContact = contact => __awaiter(void 0, void 0, void 0, function* () {
    var res = yield sendConsultantRequestContact(contact);
    if (res && mailConfirmed.value)
      //If the email is not confirmed, we won't increase the counter!
      increaseRequestCounter();
    return res;
  });
  return {
    favoritesCounter,
    getFavoriteById,
    name,
    email,
    mailConfirmed,
    favoriteIdList,
    requestsCounter,
    savedSearchesCounter,
    lastLoginDate,
    publicUserId,
    marketing,
    initState,
    setMarketing,
    setSavedSearches,
    increaseSavedSearches,
    decreaseSavedSearchesCounter,
    setUserFavorite,
    increaseRequestCounter,
    resetPublicUserMenuStore,
    getPublicUserMenuInfo,
    addSaveSearch,
    deleteSavedSearches,
    deleteSaveSearchById,
    addFavorite,
    removeFavorite,
    removeFavorites,
    sendAgencyContact,
    sendConsultantAuctionContact,
    lastFavouriteModifiedId
  };
});